// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
window._ = require('lodash');

import Vue from 'vue'
import App from './App'
import resource from 'vue-resource'
import store from './store'
import router from './router'

import 'vis/dist/vis-timeline-graph2d.min.css'

/* PLAYER */

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
import '@videojs/http-streaming'

Vue.use(VueVideoPlayer)

import VueSimplemde from 'vue-simplemde'
import 'simplemde/dist/simplemde.min.css'

Vue.component('vue-simplemde', VueSimplemde)


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

/* Vuetify */

import Vuetify from 'vuetify'
import "vuetify/dist/vuetify.min.css"

Vue.use(Vuetify)

import "intersection-observer"

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)

/* Phoenix socket */
import Socket from './lib/cloudserver'

/* Font-Awesome */
import 'font-awesome-webpack-4'

Vue.use(resource)
//Vue.use(ElementUI, { locale })
Vue.use(Socket, Config.ws_server+"/admin", {logger: ((kind, msg, data) => { /*console.log(`${kind}: ${msg}`, data)*/ })});

import moment from 'moment';

var locale = window.navigator.userLanguage || window.navigator.language;
moment.locale(locale);


const API_SERVER = Config.api_server;
Vue.http.options.root = API_SERVER+"/api/v1";

// Set default Authorization headers for internal use.
// Vue.http.get() can't be used for external API calls because this leaks the token. Use Fetch API for external calls.
if (localStorage.getItem('token') != null) {
  Vue.http.headers.common['Authorization'] = localStorage.getItem('token');
}

function verify(cb) {
  Vue.http.get("verify").then((response) => {
    if (response.body.result == true) {
      cb(true);
    } else {
      cb(false);
    }
  }, (response) => {
    cb(false);
  });
}

function check_maintenance(cb) {
  const Http = new XMLHttpRequest();
  const url='/maintenance.json?'+Date.now();
  try {
    Http.open("GET", url);
    Http.send();
  } catch(e) {
    console.log("Check maintenance error");
    return;
  }

  Http.onreadystatechange = (e) => {
    if (Http.readyState == 4 && Http.status == 200) {
      try {
        var resp = JSON.parse(Http.responseText);
        store.state.maintenance.running = true;
        store.state.maintenance.info = resp;
        if(typeof(cb) == 'function') cb();
      } catch (e) {
        store.state.maintenance.running = false;
        store.state.maintenance.info = {};
        if(typeof(cb) == 'function') cb();
      }
    } else if(Http.status != 200) {
      store.state.maintenance.running = false;
      store.state.maintenance.info = {};
      if(typeof(cb) == 'function') cb();
    }
  }
}
Vue.prototype.$check_maintenance = check_maintenance;

check_maintenance();
setInterval(check_maintenance, 10000);

router.beforeEach((to, from, next) => {
  if(typeof(to.query.view) != "undefined") {
    store.commit("set_view", to.query.view || "normal");
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.logged_in != true) {
      verify(function(ret) {
        if (ret == true) {
          store.state.logged_in = true;
          store.dispatch("logged_in");
          next();
        } else {
          Vue.Socket.disconnect();
          next({
            path: "/login",
            query: { redirect: to.fullPath }
          });
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  if (store.state.logged_in == true) {
    checkBottomSheet(to);
  }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
window.app = new Vue({
  data: {
    bottomSheet: false,
    bottomSheetFullscreen: (localStorage.getItem("bottom-sheet-fullscreen") == "true"),
    loaded: false
  },
  methods: {
    fullscreen_bottom_sheet() {
      this.bottomSheetFullscreen = !this.bottomSheetFullscreen;
      localStorage.setItem('bottom-sheet-fullscreen', this.bottomSheetFullscreen);
    },
    close_bottom_sheet() {
      this.bottomSheet = false;
    }
  },
  watch: {
    bottomSheet (val) {
      if(!val) {
        var to = this.$route;
        var route = to.matched.find((item) => { return item.regex.test(to.path); });
        if(typeof(route) != "undefined" && typeof(route.components.bottomEditor) != "undefined") {
          if(route.parent.name) {
            this.$router.push({name: route.parent.name, params: to.params});
          } else {
            this.$router.push(route.parent.path);
          }
        }
      }
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");

function checkBottomSheet(to) {
  var route = to.matched.find((item) => { return item.regex.test(to.path); });
  if(typeof(route) != "undefined" && typeof(route.components.bottomEditor) != "undefined") {
    window.app.bottomSheet = true
  } else {
    window.app.bottomSheet = false
  }
}

Vue.prototype.$is_admin = () => {
  return app.$store.getters.is_privilege(["admin", "device_admin", "root", "developer"]);
}
Vue.prototype.$is_privilege = (list) => {
  return app.$store.getters.is_privilege(list);
}
Vue.prototype.$account_type = () => {
  return app.$store.getters.account_type;
}
Vue.prototype.$dark = () => {
  return true;
}
Vue.prototype.$compact_view = () => {
  return app.$store.getters.view == "compact" || app.$store.getters.view == "popup";
}
Vue.prototype.$popup_view = () => {
  return app.$store.getters.view == "popup";
}
